// extracted by mini-css-extract-plugin
export default {"view":"View_view__AOIi8","title":"View_title__DyQe1","grey_view":"View_grey_view__aNmci","spin_wrapper":"View_spin_wrapper__Boy5C"};